export const SET_KIOSK_SETTINGS = 'SET_KIOSK_SETTINGS'



// WEBPACK FOOTER //
// ./src/types/kioskSettings.js